import React from 'react'
import { Nav, Navbar, Container, Row, Col } from 'react-bootstrap'
import { Link, Outlet } from 'react-router-dom'
import { Router } from 'app'
import { AuthView } from './AuthView'
import { FlashBoard } from './FlashBoard'
import 'style/component/layout/headerLayout.css'

export const HeaderLayout = (props) =>
    <>
        <Navbar bg='dark' variant='dark' sticky='top'>
            <Container fluid>
                <Navbar.Brand className='header-title'>
                    <Link to={Router.routes.INDEX.path} style={{ fontVariantCaps: 'small-caps' }}>
                        Sohani Academy
                    </Link>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className='ms-auto' style={{ float:'right'}}>
                        <AuthView />
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
        <FlashBoard />
        <Outlet />
        <div style={{ minHeight: '25vh' }}></div>
    </>

